"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// @ts-ignore
import assert from "@brillout/assert";
import { youtubeStart, youtubeStop, youtubeIsPlaying, youtubeNoUrl } from "./youtubeAlarm";
import { audioStart, audioStop } from "./audioAlarm";
import { sleep } from "../../../../tab-utils/sleep";
import { AsyncState } from "../../../../tab-utils/AsyncState";
export { notifyStart, notifyStop, notifyUpdate, debugLog };
var YOUTUBE_TIMEOUT = 5; //*

var DEBUG_NOTIFY = false;
/*/
const DEBUG_NOTIFY = true;
//*/

var _ref = new AsyncState({
  isStarted: false
}, update),
    state = _ref.state,
    runUpdate = _ref.runUpdate;

function notifyStop() {
  debugLog("[notify] notifyStop");
  state.isStarted = false;
}

function notifyStart() {
  debugLog("[notify] notifyStart");
  state.isStarted = true;
} // For when the user:
//  - changes themes, or
//  - change the YouTube URL


function notifyUpdate() {
  runUpdate();
}

function update(isNotLastUpdate) {
  if (!state.isStarted) {
    stop();
  }

  if (state.isStarted) {
    stop();
    start(isNotLastUpdate);
  }
}

function stop() {
  debugLog("[notify] stop");
  youtubeStop();
  audioStop();
}

function start(_x) {
  return _start.apply(this, arguments);
}

function _start() {
  _start = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(isNotLastUpdate) {
    var noYoutube, isStarted, ytIsPlaying;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            debugLog("[notify] start");
            assert(state.isStarted === true);
            noYoutube = youtubeNoUrl();
            debugLog("[notify] youtubeNoUrl():", noYoutube);

            if (!noYoutube) {
              _context.next = 7;
              break;
            }

            audioStart();
            return _context.abrupt("return");

          case 7:
            youtubeStart();
            _context.next = 10;
            return sleep({
              seconds: YOUTUBE_TIMEOUT
            });

          case 10:
            if (!isNotLastUpdate()) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return");

          case 12:
            // Since it is the last call, `isStarted` is left untouched.
            isStarted = state.isStarted;
            assert(isStarted === true, {
              isStarted: isStarted
            });
            ytIsPlaying = youtubeIsPlaying();
            debugLog("[notify] youtubeIsPlaying:", ytIsPlaying);

            if (!ytIsPlaying) {
              youtubeStop();
              audioStart();
            }

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _start.apply(this, arguments);
}

function debugLog() {
  var _console;

  if (!DEBUG_NOTIFY) return;

  (_console = console).log.apply(_console, arguments);
}